import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import { RootState } from "./types";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { general } from "@/store/general";
import { auth } from "@/store/auth";
import { course } from "@/store/course";
import { bundleCourse } from "@/store/bundle-course";
import { myCourse } from "@/store/my-course";
import { payment } from "@/store/payment";
import { instructor } from "@/store/instructor";

Vue.use(Vuex);

const savedLocale = localStorage.getItem("locale");
const locale = savedLocale === "en" || savedLocale === "id" ? savedLocale : "id";

const store: StoreOptions<RootState> = {
  modules: {
    general,
    auth,
    course,
    bundleCourse,
    myCourse,
    payment,
    instructor,
  },
  state: {
    locale,
    layout: "main-layout",
    theme_color: 1,
    app_login: null,
  },
  mutations,
  actions,
  getters,
};

export default new Vuex.Store<RootState>(store);
